import React from 'react';
import {Link} from 'react-router-dom';
import {store} from 'base/reducers';
import {Categories} from 'api';
import CONFIG from 'base/constants/config';

class CategoryBox extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  handleDelete(catID, e) {
    if (confirm("Bạn có muốn xóa danh mục này không? Sau khi xóa, các sản phẩm và doanh nghiệp thuộc về  danh mục này sẽ không truy cập được")) {
      store.dispatch(Categories.actions.delete({ id: catID })).then(response => {
        // store.dispatch({
        //   type: 'REMOVE_CATEGORY',
        //   id: catID
        // });
        store.dispatch(Categories.actions.list());
      });
    }
  }

  goEdit(id) {
    this.props.history.push(`/categories/edit/${id}`);
  }

  render() {
    let img = require('assets/images/placeholder-128.jpg');

    if (this.props.data.logo) {
      img = `${CONFIG.staticURL}/category-logos/${this.props.data.logo}`;
    }

    return (
      <table className="table table-striped" style={{width: '48%', margin: 10, background: '#fff', borderRadius: 15}}>
        <tbody>
          <tr style={{background: '#ddd'}}>
            <td colSpan='2'><h4><i className={this.props.data.largeIcon} style={{fontSize: 24}}></i> {this.props.data.name}</h4></td>
            <td>
              <Link to={`/categories/edit/${this.props.data.id}`} className="btn-actions"><span className="glyphicon glyphicon-pencil" aria-hidden="true"></span></Link> &nbsp;
              <a onClick={this.handleDelete.bind(this, this.props.data.id)} className="btn-actions"><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></a>
            </td>
          </tr>
        </tbody>
        <tbody>
          {
            this.props.data.children && this.props.data.children.length > 0 &&
            this.props.data.children.map(item => {
              return (
                <tr>
                  <td style={{width: 50}}><i className={item.smallIcon}></i></td>
                  <td><span>{item.name}</span></td>
                  <td>
                    <Link to={`/categories/edit/${item.id}`} className="btn-actions"><span className="glyphicon glyphicon-pencil" aria-hidden="true"></span></Link> &nbsp;
                    <a onClick={this.handleDelete.bind(this, item.id)} className="btn-actions"><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></a>
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    );
  }
}

export default CategoryBox;



// WEBPACK FOOTER //
// ./components/category/CategoryBox.jsx